export default __webpack_public_path__ + "static/media/misc-closetB-480w.97f6b925.webp";